import { render, staticRenderFns } from "./STableTypeExpenseComp.vue?vue&type=template&id=1195033f&"
import script from "./STableTypeExpenseComp.vue?vue&type=script&lang=js&"
export * from "./STableTypeExpenseComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports